// AdSense + CSE values are read from Vite env vars so they can be changed in
// one place (.env) without editing this file. Fallbacks preserve current live
// values so nothing breaks if an env var is missing.
const env = import.meta.env;

export const siteConfig = {
  siteName: "CRMWorldGuide",
  domain: "https://crmworldguide.com",
  contactEmail: "crmworldguide@gmail.com",
  description:
    "CRMWorldGuide delivers in-depth CRM, ERP, and SaaS reviews, comparisons, and buyer's guides for US business decision makers.",
  defaultOgImage:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=630&fit=crop&auto=format&q=70",
  fallbackImage:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=675&fit=crop&auto=format&q=70",
  adsensePublisherId:
    env.VITE_ADSENSE_PUBLISHER_ID || "ca-pub-3649076557244935",

  gaMeasurementId: env.VITE_GA_MEASUREMENT_ID || "G-5F4VV867F0",
  author: "CRMWorldGuide Editorial",
  nav: [
    { label: "Home", to: "/" },
    { label: "About", to: "/about-us" },
    { label: "Contact", to: "/contact-us" },
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms & Conditions", to: "/terms-condition" },
  ],
  categories: [
    "CRM Software",
    "Enterprise CRM",
    "SaaS Tools",
    "Business Tools",
  ],
} as const;

export const categorySlug = (c: string) =>
  c.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
